import { HttpRequestMethod, send } from "./utils/send";

export const sendGetOrganizationClientSecret = (): Promise<string> =>
  send<string>("/organizations", HttpRequestMethod.GET);
